import React from "react";
import { Button, Stack, Typography } from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import RefreshIcon from "@mui/icons-material/Refresh";

/**
 * Estado de error: algo falló al cargar. Dice qué pasó y cómo seguir, sin códigos técnicos.
 *
 * @param {object} props
 * @param {React.ReactNode} [props.titulo] Por defecto "No se pudo cargar la información".
 * @param {React.ReactNode} [props.mensaje] Qué pasó y cómo seguir.
 * @param {Function} [props.onReintentar] Si se pasa, muestra el botón "Reintentar".
 * @param {boolean} [props.anunciar] Con false no lleva role="alert": cuando varias tarjetas fallan
 *   por la misma causa, el lector de pantalla lo anuncia una sola vez.
 */
export const EstadoError = ({
  titulo = "No se pudo cargar la información",
  mensaje = "Revisa tu conexión e inténtalo de nuevo.",
  onReintentar,
  anunciar = true,
}) => (
  <Stack
    role={anunciar ? "alert" : undefined}
    alignItems="center"
    textAlign="center"
    spacing={1.5}
    sx={{ py: 6, px: 2 }}
  >
    <ErrorOutlineIcon aria-hidden="true" sx={{ fontSize: 56, color: "error.main" }} />
    <Typography
      component="p"
      variant="h6"
      sx={{ fontWeight: 700, color: "text.primary" }}
    >
      {titulo}
    </Typography>
    {mensaje && (
      <Typography
        variant="body2"
        sx={{ color: "text.secondary", maxWidth: 420 }}
      >
        {mensaje}
      </Typography>
    )}
    {onReintentar && (
      <Button
        variant="outlined"
        startIcon={<RefreshIcon />}
        onClick={onReintentar}
        sx={{ mt: 1 }}
      >
        Reintentar
      </Button>
    )}
  </Stack>
);
